/* ==========================================================================
   ATB STICKY ATC — logic for the mobile sticky add-to-cart bar.
   Pairs with atb-sticky-atc.css + snippets/atb-sticky-atc.liquid.

   Principles:
   - REUSE, don't re-implement: the bar's button clicks the real
     #ProductSubmitButton-<sectionId>, so variant/quantity/cart-drawer all
     go through Dawn's product-form.
   - Price + button label stay in sync by observing the section's real
     price element and submit button (MutationObserver) — survives Dawn's
     variant-change re-renders without depending on pubsub internals.
   - While visible, sets --atb-sticky-atc-offset on <html> so the Ask Adam
     launcher lifts above the bar (rule lives in atb-sticky-atc.css).
   ========================================================================== */

(function () {
  'use strict';

  function initBar(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    if (!sectionId) return;

    var realBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!realBtn) return; // no buy button (e.g. gift card edge) — bar stays hidden

    var priceEl = document.getElementById('price-' + sectionId);
    var barPrice = bar.querySelector('[data-sticky-price]');
    var barBtn = bar.querySelector('[data-sticky-submit]');
    var barBtnText = bar.querySelector('[data-sticky-btn-text]');

    function syncPrice() {
      if (!priceEl || !barPrice) return;
      var sale = priceEl.querySelector('.price--on-sale .price-item--sale');
      var regular = priceEl.querySelector('.price__regular .price-item--regular');
      var el = sale || regular;
      if (el && el.textContent.trim()) barPrice.textContent = el.textContent.trim();
    }

    function syncButton() {
      if (barBtnText) {
        var span = realBtn.querySelector('span');
        var label = (span || realBtn).textContent.trim();
        if (label) barBtnText.textContent = label;
      }
      var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      barBtn.disabled = disabled;
      barBtn.classList.toggle('is-disabled', disabled);
    }

    syncPrice();
    syncButton();

    var observerConfig = { subtree: true, childList: true, characterData: true, attributes: true };
    if (priceEl) new MutationObserver(syncPrice).observe(priceEl, observerConfig);
    new MutationObserver(syncButton).observe(realBtn, observerConfig);

    // ---- Variant sheet (multi-variant products) --------------------------
    // The sheet's pills PROXY the section's real <variant-selects> radios:
    // tapping a pill clicks the real input so Dawn's product-info handles
    // availability / price / media swaps; we just mirror its state.
    var sheet = document.getElementById('AtbStickyVp-' + sectionId);
    var variantSelects = document.querySelector('#variant-selects-' + sectionId)
      || document.querySelector('variant-selects');

    function realRadios() {
      return variantSelects
        ? Array.prototype.slice.call(variantSelects.querySelectorAll('input[type="radio"]'))
        : [];
    }

    function buildSheetOptions() {
      if (!sheet || !variantSelects) return;
      var wrap = sheet.querySelector('[data-vp-options]');
      wrap.innerHTML = '';
      variantSelects.querySelectorAll('fieldset').forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend, .form__label');
        var row = document.createElement('div');
        row.className = 'atb-sticky-vp__option-row';
        var label = document.createElement('p');
        label.className = 'atb-sticky-vp__option-label';
        label.textContent = legend ? legend.textContent.trim() : '';
        row.appendChild(label);
        var values = document.createElement('div');
        values.className = 'atb-sticky-vp__option-values';
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'atb-sticky-vp__option-value';
          pill.textContent = input.value;
          if (input.checked) pill.classList.add('is-selected');
          if (input.classList.contains('disabled')) pill.classList.add('is-disabled');
          pill.addEventListener('click', function () {
            input.click();
            // Dawn re-renders the picker section HTML on variant change
            // (async section render); rebuild once fast for responsiveness
            // and once late to catch a slow render.
            setTimeout(refreshSheet, 350);
            setTimeout(refreshSheet, 1000);
          });
          values.appendChild(pill);
        });
        row.appendChild(values);
        wrap.appendChild(row);
      });
      syncSheetFooter();
    }

    function syncSheetFooter() {
      if (!sheet) return;
      var vpPrice = sheet.querySelector('[data-vp-price]');
      var vpConfirm = sheet.querySelector('[data-vp-confirm]');
      var vpConfirmText = sheet.querySelector('[data-vp-confirm-text]');
      if (vpPrice && barPrice) vpPrice.textContent = barPrice.textContent;
      if (vpConfirm) {
        var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
        vpConfirm.disabled = disabled;
        if (vpConfirmText) {
          var span = realBtn.querySelector('span');
          var label = (span || realBtn).textContent.trim();
          if (label) vpConfirmText.textContent = label;
        }
      }
    }

    function refreshSheet() {
      // variant-selects may have been re-rendered — re-resolve it.
      variantSelects = document.querySelector('#variant-selects-' + sectionId)
        || document.querySelector('variant-selects');
      syncPrice();
      syncButton();
      buildSheetOptions();
    }

    function openSheet() {
      refreshSheet();
      sheet.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      sheet.hidden = true;
      document.body.style.overflow = '';
    }

    if (sheet) {
      sheet.querySelectorAll('[data-vp-close]').forEach(function (el) {
        el.addEventListener('click', closeSheet);
      });
      var vpConfirmBtn = sheet.querySelector('[data-vp-confirm]');
      vpConfirmBtn.addEventListener('click', function () {
        if (vpConfirmBtn.disabled) return;
        closeSheet();
        realBtn.click();
      });
      // Keep the sheet footer (price + label) in sync with the real form
      if (priceEl) new MutationObserver(syncSheetFooter).observe(priceEl, observerConfig);
      new MutationObserver(syncSheetFooter).observe(realBtn, observerConfig);
    }

    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      if (sheet && realRadios().length > 0) {
        openSheet();
      } else {
        realBtn.click();
      }
    });

    // Visibility: show once the buy box has scrolled above the viewport.
    // rAF-throttled scroll check rather than IntersectionObserver: with
    // threshold 0, a fast jump from below-viewport to above-viewport never
    // changes intersection state, so IO silently misses it.
    var visible = false;
    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('is-visible', next);
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
      document.documentElement.classList.toggle('atb-sticky-atc-open', next);
      document.documentElement.style.setProperty(
        '--atb-sticky-atc-offset',
        next ? bar.offsetHeight + 'px' : '0px'
      );
    }

    var watchTarget = realBtn.closest('form') || realBtn;
    var ticking = false;
    function check() {
      ticking = false;
      setVisible(watchTarget.getBoundingClientRect().bottom < 0);
    }
    function requestCheck() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }
    window.addEventListener('scroll', requestCheck, { passive: true });
    window.addEventListener('resize', requestCheck, { passive: true });
    check();
  }

  function init() {
    document.querySelectorAll('.atb-sticky-atc').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
